import React from "react";
import ReactTable from "react-table";
import _ from "underscore";
import { generateColumns, readyAllCheck } from "~/app/utilities";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addQueudedClaims } from "~/app/submit_claims/claims_table/actions";
import { addUploadedClaims, addViewClaims, isRecentBatch, readyAllClick } from "~/app/submit_claims/upload/actions";
import FontAwesome from "react-fontawesome";
import CMS1500 from "./cms_1500/CMS1500";
import ClaimLog from "./claim_log/ClaimLog";
import NEWCMS1500 from "./cms_1500/newCMS1500"
class CommonTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: {},
      selectAll: 0,
      rowData: {},
      logRowData: {}
    };
    this.toggleRow = this.toggleRow.bind(this);
  }

  toggleRow(ins_number) {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[ins_number] = !this.state.selected[ins_number];
    this.setState({
      selected: newSelected,
      selectAll: 2
    });

    this.props.addQueudedClaims(newSelected);
  }

  //this function selects the rows that are ready for submission. Input is all claims without any errors
  toggleSelectAll = claims => {
    let newSelected = {};
    claims.forEach(x => {
      if (x.status === "Ready") {
        newSelected[x["remote_claimid"]] = true;
      }
    });
    this.setState({
      selected: newSelected,
      selectAll: 1
    });


    this.props.addQueudedClaims(newSelected);
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.ready_all_click) {
      this.readyAllClaims(); // doing the ready all check
      this.props.readyAllClick(false); // setting readyAll to false so that it can be clicked again
    }

    const selClaimIDs = Object.keys(this.state.selected);
    if (this.props.view_claims !== prevProps.view_claims && prevProps.view_claims.length === this.props.view_claims.length) { // to make sure we deselect the row when status changes from ready to error
      _.each(this.props.view_claims, (claim, index) => {
        if (prevProps.view_claims[index].status === "Ready" && claim.status === 'R' && selClaimIDs.includes(claim.remote_claimid)) {
          this.toggleRow(claim.remote_claimid);
        }
      })
    }
  }

  readyAllClaims = () => {
    const allClaims = this.props.view_claims;
    const result = readyAllCheck(allClaims); // return claims with errors and claim ids with errors
    const claimsErrObj = result[0];
    const errorClaimIDs = result[1];

    const viewClaimsErrors = _.filter(this.props.view_claims, claim => {
      //All Claim data for error claims
      return _.contains(errorClaimIDs, claim.remote_claimid);
    });
    const viewClaimsNoErrors = _.difference(allClaims, viewClaimsErrors); // all claim data for no error claims

    this.updateClaimsWithErrors(
      viewClaimsErrors,
      viewClaimsNoErrors,
      claimsErrObj
    );
    this.toggleSelectAll(viewClaimsNoErrors);
  };

  updateClaimsWithErrors = (
    viewClaimsErrors,
    viewClaimsNoErrors,
    claimsErrObj
  ) => {
    let viewClaimsErrorsWithObj = [];
    _.each(claimsErrObj, error => {
      _.each(viewClaimsErrors, claim => {
        if (claim.remote_claimid === error.claim_id) {
          claim.error = error.error;
          claim.status = "R";
        }
        viewClaimsErrorsWithObj.push(claim);
      });
    });

    const updatedClaims = _.union(viewClaimsNoErrors, viewClaimsErrorsWithObj);
    this.props.addViewClaims(updatedClaims);
    this.props.isRecentBatch(false);
    const groupedUpdatedClaims = _.groupBy(updatedClaims, claim => {
      return claim.file_name;
    });
    //changing groupedUpdatedClaims to array for viewUploadedClaims to work
    let groupedClaimsArr = [];
    _.each(groupedUpdatedClaims, val => {
      groupedClaimsArr.push(val);
    });

    this.props.addUploadedClaims(groupedClaimsArr);
  };

  handleHeaderCheckbox = selectAll => {
    if (selectAll === 0) {
      this.readyAllClaims();
    } else if (selectAll === 1 || selectAll === 2) {
      this.setState({ selected: {}, selectAll: 0 });
      this.props.addQueudedClaims({});
    }
  };

  handleRowCheckbox = (claim, e) => {
    if (claim.status === "Ready") {
      this.toggleRow(claim.remote_claimid);
    } else {
      e.preventDefault();
    }
  };
  render = () => {
    let data = this.props.data;
    if (this.props.searchTerm) {
      data = data.filter(row => {
        return (
          row["First Name"]
            .toUpperCase()
            .includes(this.props.searchTerm.toUpperCase()) ||
          row["Last Name"]
            .toUpperCase()
            .includes(this.props.searchTerm.toUpperCase()) ||
          row["Patient ID"]
            .toUpperCase()
            .includes(this.props.searchTerm.toUpperCase()) ||
          row["Date of Service"]
            .toUpperCase()
            .includes(this.props.searchTerm.toUpperCase()) ||
          row["Insurance Number"]
            .toUpperCase()
            .includes(this.props.searchTerm.toUpperCase())
        );
      });
      //sthis.props.addViewClaims(data)
    }

    let columns = [
      {
        id: "checkbox",
        accessor: "",
        Cell: ({ original }) => {
          return (
            <div>
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selected[original["remote_claimid"]] === true}
                onChange={e => this.handleRowCheckbox(original, e)}
              />
            </div>
          );
        },
        Header: x => {
          return (
            <div>
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.handleHeaderCheckbox(this.state.selectAll)}
              />
            </div>
          );
        },
        sortable: false,
        filterable: false,
        width: 35,
        resizable: false,
        // show: this.props.is_recent_batch?false:true,
      },
      {
        Header: "",
        id: "editClaim-btn",
        Cell: ({ row }) => (
          <FontAwesome
            className="icon-edit"
            name="pencil alt"
            onClick={e => this.handleEditButtonClick(e, row)}
          />
        ),
        maxWidth: 30,
        sortable: false,
        filterable: false,
        resizable: false,
        // show: this.props.is_recent_batch?false:true,
      },
      {
        Header: "",
        id: "viewClaim-btn",
        Cell: ({ row }) => (
          <FontAwesome
            className="icon-view"
            name="info-circle"
            onClick={e => this.handleLogButtonClick(e, row)}
          />
        ),
        maxWidth: 30,
        sortable: false,
        filterable: false,
        resizable: false
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: row => (
          <div
            style={{
              width: "100%",
              height: "100%",
              transition: "all .2s ease-out",
              borderTop: setStatusColor(row.value)
            }}
          >
            <span>
              {row.value === "Ready"
                ? "Ready"
                : row.value === "A"
                  ? `Acknowledged`
                  : row.value === "R"
                    ? `Rejected`
                    : "Invalid Status"}
            </span>

            {this.renderLatestStatus(row.row.remote_claimid)}

          </div>
        ),
        width: 100
      }
    ];

    const headersArray = generateColumns(this.props.data);
    _.each(headersArray, headerObj => {
      columns.push(headerObj);
    });

    return (
      <div>
        <ReactTable
          className="-striped -highlight"
          data={data}
          columns={columns} //defaultSorted={[{ id: "firstName", desc: false }]}
          sortable={true}
          showPageSizeOptions={true}
          defaultPageSize={10}
          noDataText={"No Claims Uploaded!"}
        />
        <CMS1500
          rowData={this.state.rowData}
          view_claims={this.props.view_claims}
        />

        {/* <NEWCMS1500
          rowData={this.state.rowData}
        /> */}
        <ClaimLog
          logRowData={this.state.logRowData}
        />
      </div>
    );
  };

  handleEditButtonClick = (e, row) => {
    const clickedClaim = _.find(this.props.view_claims, claim => {
      return row.remote_claimid === claim.remote_claimid;
    });
    const newClickedClaim = _.create("", clickedClaim); // new ref to rerender cms1500 even if the same row was clicked more than once
    this.setState({ rowData: newClickedClaim });
  };

  handleLogButtonClick = (e, row) => {
    const clickedClaim = _.find(this.props.view_claims, claim => {
      return row.remote_claimid === claim.remote_claimid;
    });
    const newClickedClaim = _.create("", clickedClaim); // new ref to rerender claimLog even if the same row was clicked more than once
    this.setState({ logRowData: newClickedClaim });
  };

  renderLatestStatus = (claimID) => {
    const allClaims = this.props.view_claims;

    return _.map(allClaims, claim => {
      if (claim.remote_claimid === claimID && !_.isEmpty(claim.claimLog)) {
        if (!_.isEmpty(claim.claimLog.logs)) {
          let lastStatus = _.last(claim.claimLog.logs)
          return (
            <div className="last-status">
              {lastStatus.message.message}
            </div>
          )
        }
      }
    })
  }
}

function setStatusColor(status) {
  let border = "";
  status === "Ready"
    ? (border = "4px solid #6ccc93")
    : status === "A"
      ? (border = "4px solid #1abc9c")
      : status === "R"
        ? (border = "4px solid #e00007")
        : (border = "4px solid #e00007");
  return border;
}

const mapStateToProps = state => {
  return {
    view_claims: state.submitClaims.view_claims,
    upload_check: state.submitClaims.upload_check,
    is_recent_batch: state.submitClaims.is_recent_batch,
    ready_all_click: state.submitClaims.ready_all_click,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addQueudedClaims, addUploadedClaims, addViewClaims, isRecentBatch, readyAllClick,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CommonTable);



// WEBPACK FOOTER //
// ./src/app/common/CommonTable.js